module.exports = __webpack_public_path__ + "static/img/Wow5f15f9.364699f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/emoji/Wow5f15f9.png
// module id = Ue0T
// module chunks = 1